














import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { TransactionFilter } from "@/shared/types";
import HsaLineChart from "@/shared/components/charts/HsaLineChart.vue";
import CashAccountTabs from "@/shared/components/cash/CashAccountTabs.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabCashAccountTabs from "@/shared/components/cash/hsabank/HsabCashAccountTabs.vue";

@Component({
  components: {
    HsaLineChart,
    CashAccountTabs,
    GenericLoadingSpinner,
    HsabCashAccountTabs
  }
})
export default class CashTransactions extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();

  mounted () {
    const args: any = { username: this.username, partnerId: this.partnerId };
    this.custodianSettingsStore.getCustodianSettings(args);
  }

  isLoaded () {
    return this.custodianSettingsStore.isLoaded;
  }

  @Prop()
  page: number;

  @Prop()
  routeToPages: (routeToPages: number, filter: TransactionFilter) => Location;

  @Prop()
  transactionFilter: TransactionFilter;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  get displayHsabCashAccountTabs () {
    return this.custodianSettingsStore.isHsaBankCustodian &&
        this.featureFlagStore.flags.bend16322EnableHsabTransactions;
  }
}

